import styled from 'styled-components'
import { Typography } from '@chegg-ui/typography'
import { font, spacing } from '@chegg-ui/theme'

export const AllCardsAcceptedHeading = styled(Typography).attrs({
  variant: 'h1',
  variantType: 'bold',
})`
  font-size: ${font.size.px24};
  line-height: ${font.lineHeight.md};
  margin-top: ${spacing.px16};
  margin-bottom: ${spacing.px12};
  padding: 0 ${spacing.px16};
`
